import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LANGS = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'de', label: 'Deutsch' },
  { value: 'tl', label: 'Filipino' },
  { value: 'pt', label: 'Português' },
  { value: 'ar', label: 'العربية' },
];

export const LanguageSwitcher = ({ className = '' }) => {
  const { lang, setLang } = useLanguage();
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="language-switcher">
      <Globe size={14} className="text-gray-400 flex-shrink-0" />
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className="bg-transparent text-sm font-medium text-gray-600 cursor-pointer focus:outline-none hover:text-[#7B4FD8]"
        data-testid="language-select"
        aria-label="Language"
      >
        {LANGS.map((l) => (
          <option key={l.value} value={l.value}>{l.label}</option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
